import React from "react";
import { notify } from "../Notification";
import usePlayer, { player } from "../../hooks/usePlayer";
import { CONTEXTS } from "../../data/tracks";
import { LIBRARY } from "../../data/spotify";
import { Cover } from "./Library";
import { formatDuration } from "./PlaylistPage";

// Search: the songs that play here, then what's in the library, that match.
const SearchPage = ({ query, onOpen }) => {
  const { playlist, index, playing } = usePlayer();
  const q = query.trim().toLowerCase();
  const songs = Object.values(CONTEXTS).flatMap((list) =>
    list.tracks
      .map((track, i) => ({ track, i, list }))
      .filter(({ track }) => `${track.title} ${track.artists.join(" ")}`.toLowerCase().includes(q)),
  );
  const items = LIBRARY.filter((item) => `${item.title} ${item.by}`.toLowerCase().includes(q));

  return (
    <div className="sp-search-page">
      {songs.length > 0 && (
        <section>
          <h2 className="sp-section-title">Songs</h2>
          {songs.slice(0, 8).map(({ track, i, list }) => {
            const current = playlist.id === list.id && index === i;
            return (
              <button
                type="button"
                key={`${list.id}-${i}`}
                className={`sp-result ${current ? "is-current" : ""}`}
                onClick={() => (current ? player.toggle() : player.play(list.id, i))}
                aria-label={current && playing ? `Pause ${track.title}` : `Play ${track.title}`}
              >
                <img src={track.image} alt="" className="sp-result-cover" draggable={false} />
                <span className="sp-result-text">
                  <span className="sp-result-title">{track.title}</span>
                  <span className="sp-result-sub">{track.artists.join(", ")}</span>
                </span>
                <span className="sp-result-duration">{formatDuration(track.duration)}</span>
              </button>
            );
          })}
        </section>
      )}
      {items.length > 0 && (
        <section>
          <h2 className="sp-section-title">In Your Library</h2>
          {items.map((item) => (
            <button
              type="button"
              key={item.id}
              className="sp-result"
              onClick={() =>
                item.open
                  ? onOpen(item.open)
                  : notify(`${item.title} plays in Spotify itself. ICEMAN and Liked Songs play here.`)
              }
            >
              <Cover item={item} className="sp-result-cover" />
              <span className="sp-result-text">
                <span className="sp-result-title">{item.title}</span>
                <span className="sp-result-sub">
                  {item.kind} • {item.by}
                </span>
              </span>
            </button>
          ))}
        </section>
      )}
      {!songs.length && !items.length && (
        <div className="sp-no-results">
          <p className="sp-no-results-title">No results found for "{query.trim()}"</p>
          <p>Check the spelling, or search for something else. ICEMAN and Liked Songs play here.</p>
        </div>
      )}
    </div>
  );
};

export default SearchPage;
